"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactAgent = void 0;
var React = require("react");
var react_redux_1 = require("react-redux");
var classnames_1 = require("classnames");
var ContactAgentAction_1 = require("@/pages/contactAgent/actions/ContactAgentAction");
var propertyToPriceShort_1 = require("@/transformers/propertyToPriceShort");
var PublicPage_1 = require("@/pages/common/components/PublicPage");
var EnquiryForm_1 = require("@/pages/common/components/EnquiryForm");
var mapStateToProps = function (state) { return (__assign(__assign({}, state.contactAgent), { user: state.user, currencyMap: state.layout.currencies.options, offices: state.layout.offices })); };
var mapDispatchToProps = function (dispatch) { return ({
    onConfirmClicked: function (form, e) {
        return dispatch(ContactAgentAction_1.default.onConfirmClicked(form, e.currentTarget.id));
    },
}); };
exports.contactAgent = function (props) {
    var noBudget = true;
    var pageHeaderClass = classnames_1.default([
        "c-page-header",
        "c-page-header--center",
        "c-page-header--center-mobile",
    ]);
    var isLoading = props.isLoading, enquiry = props.enquiry, tForm = props.tForm, salutations = props.salutations, favorites = props.favorites, favoritesInt = props.favoritesInt, user = props.user, onConfirmClicked = props.onConfirmClicked, t = props.t;
    var renderFavItem = function (item, index, t) {
        var itemClass = classnames_1.default([
            "c-fav__item",
            {
                "c-fav__item--disabled": !item.available,
            },
        ]);
        return (React.createElement("div", { key: index, className: itemClass },
            React.createElement("div", { className: "c-fav__img c-fav__img--circle" },
                React.createElement("img", { src: item.images.length ? item.images[0].path : "", alt: item.images.length ? item.images[0].caption : "" })),
            React.createElement("div", { className: "c-fav__info" },
                React.createElement("div", { className: "c-fav__name" }, item.building),
                React.createElement("div", { className: "c-fav__caption" }, item.available
                    ? propertyToPriceShort_1.toPrice(item, props.currencyMap)
                    : t.nameUnavailable))));
    };
    var renderFavItems = function (favs, t) {
        return favs.map(function (item, index) {
            return renderFavItem(item, index, t);
        });
    };
    var sideClasses = classnames_1.default([
        "c-npage__side",
        {
            "u-hidden": !favorites.length && !favoritesInt.length,
        },
    ]);
    var renderFavSection = function (favorites, t) {
        if (!favorites.length)
            return;
        return (React.createElement("div", { className: "c-npage__fav" },
            React.createElement("div", { className: "c-fav__block js-fav-title__anchor" },
                React.createElement("div", { className: "c-fav__section" },
                    React.createElement("div", { className: "c-fav__title js-fav-title__trigger" },
                        React.createElement("div", { className: "c-fav__label " }),
                        React.createElement("span", { className: "c-fav__title-text" }, t.nameFavorite),
                        React.createElement("div", { className: "c-fav__label " })),
                    React.createElement("div", { className: "c-fav__items" }, renderFavItems(favorites, t))))));
    };
    var renderFavIntSection = function (favorites, t) {
        var newT = JSON.parse(JSON.stringify(t));
        newT.nameFavorite = newT.nameFavoriteInt;
        return renderFavSection(favorites, newT);
    };
    var renderImg = function (img) {
        return (React.createElement("div", { className: "c-contactcard__img" },
            React.createElement("img", { src: img, alt: "" })));
    };
    var renderOffice = function (office, props, hero, i) {
        if (i === void 0) { i = -1; }
        var attr = i >= 0 ? { key: i } : {};
        var _a = office.googleMap, lat = _a.lat, lng = _a.lng;
        var map = office.googleMap && office.googleMap.lat
            ? "http://www.google.com/maps/place/" + lat + "," + lng + "/@" + lat + "," + lng + ",18z"
            : null;
        return (React.createElement("div", __assign({}, attr, { className: "c-contactcard--hero" }),
            React.createElement("div", { className: "c-contactcard__info" },
                React.createElement("h3", { className: "c-contactcard__title" }, office.name),
                React.createElement("div", { className: "c-contactcard__address" }, office.address),
                React.createElement("div", { className: "c-contactcard__telephone" },
                    React.createElement("a", { className: "o-btn o-btn--flat", href: "tel:" + office.telephone.replace(/ /g, "") }, office.telephone)),
                React.createElement("div", { className: "c-contactcard__action" },
                    React.createElement("a", { target: "_blank", href: map, className: "o-btn o-btn--flat" }, props.t.openGoogleMap)))));
    };
    return (React.createElement(PublicPage_1.default, null,
        React.createElement("div", { className: "c-feature", style: { backgroundImage: "url(" + props.background + ")" } },
            React.createElement("div", { className: "c-feature__main", style: { zIndex: "auto" } },
                React.createElement("div", { className: "l-container l-container--rfull" },
                    React.createElement("div", { className: "l-container__main" },
                        React.createElement("div", { className: "l-pad--6" },
                            React.createElement("div", { id: "enquire-body", className: "c-npage__body" },
                                React.createElement("div", { className: "c-npage__wrapper" },
                                    React.createElement("div", { className: "c-npage__content" },
                                        React.createElement("div", { className: pageHeaderClass },
                                            React.createElement("div", { className: "c-page-header__body" },
                                                React.createElement("h2", { className: "c-page-header__title" }, t.nameContactAgent),
                                                React.createElement("div", { className: "c-page-header__caption" }, t.nameContactCaption))),
                                        React.createElement(EnquiryForm_1.default, { showComment: true, showSubscribe: !props.user.email }),
                                        React.createElement("div", { className: "c-npage__subcontent", dangerouslySetInnerHTML: {
                                                __html: t.namePrivacyPolicy,
                                            } })),
                                    React.createElement("div", { className: sideClasses },
                                        renderFavSection(favorites, t),
                                        renderFavIntSection(favoritesInt, t))))),
                        React.createElement("h2", { className: "c-contactcard__head" }, renderImg(props.offices[0].logo)),
                        React.createElement("div", { className: "c-contactcard--list" }, props.offices.map(function (it, i) { return renderOffice(it, props, true, i); }))))))));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(exports.contactAgent);
